import http from "@/utils/request"

export default {
	factory: {
		list: async function (data = {}) {
			return await http.get("factory/list", data);
		},
		info: async function (data = {}) {
			return await http.get("factory/info", data);
		},
		add: async function (data = {}) {
			return await http.post("factory/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("factory/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("factory/del", data);
		},
		option: async function (data = {}) {
			return await http.get("factory/option", data);
		},
	},
	qrcode: {
		list: async function (data = {}) {
			return await http.get("qrcode/list", data);
		},
		info: async function (data = {}) {
			return await http.get("qrcode/info", data);
		},
		add: async function (data = {}) {
			return await http.post("qrcode/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("qrcode/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("qrcode/del", data);
		},
		option: async function (data = {}) {
			return await http.get("qrcode/option", data);
		},
		transfer: async function (data = {}) {
			return await http.post("qrcode/transfer", data);
		},
		recall: async function (data = {}) {
			return await http.post("qrcode/recall", data);
		},
		recordList: async function (data = {}) {
			return await http.get("transfer_record/list", {...data, type: 'qrcode'});
		},
	},
	merchant_qrcode: {
		list: async function (data = {}) {
			return await http.get("merchant/qrcodes", data);
		},
		bind: async function (data = {}) {
			return await http.post("qrcode/bind", data);
		},
		unbind: async function (data = {}) {
			return await http.post("qrcode/unbind", data);
		},
	},
	device: {
		list: async function (data = {}) {
			return await http.get("device/list", data);
		},
		info: async function (data = {}) {
			return await http.get("device/info", data);
		},
		add: async function (data = {}) {
			return await http.post("device/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("device/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("device/del", data);
		},
		option: async function (data = {}) {
			return await http.get("device/option", data);
		},
		transfer: async function (data = {}) {
			return await http.post("device/transfer", data);
		},
		recall: async function (data = {}) {
			return await http.post("device/recall", data);
		},
		recordList: async function (data = {}) {
			return await http.get("device/transfer_record/list", data);
		},
	},
	merchant_device: {
		list: async function (data = {}) {
			return await http.get("merchant/devices", data);
		},
		bind: async function (data = {}) {
			return await http.post("device/bind", data);
		},
		unbind: async function (data = {}) {
			return await http.post("device/unbind", data);
		},
	},
}
